import { CSSProperties } from "react";

export const getChipTableHeaderStyles = ({
  length,
}: {
  length: number;
}): CSSProperties[] => {
  return Array.from({ length }).map((_, index) => {
    if (index === 0) {
      return {
        textAlign: "left",
      };
    } else {
      return {};
    }
  });
};
